import $ from 'jquery';
var jQueryBridget = require('jquery-bridget');
var Flickity = require('flickity');

// make Flickity a jQuery plugin
jQueryBridget( 'flickity', Flickity, $ );


// now you can use $().flickity()
$('.home--carousel').flickity({
  cellAlign: 'left',
  autoPlay: 5000,
  contain: true,
  wrapAround: true,
  resize: true,
  setGallerySize: true,
  cellSelector: '.slide',
  pageDots: false,
  prevNextButtons: true,
  lazyLoad: 1,
  imagesLoaded: true,
  accessibility: true
});

// now you can use $().flickity()
$('.carousel').flickity({
  cellAlign: 'left',
  autoPlay: 5000,
  pauseAutoPlayOnHover: true,
  contain: true,
  wrapAround: true,
  resize: true,
  setGallerySize: true,
  cellSelector: '.slide',
  pageDots: false,
  prevNextButtons: true,
  lazyLoad: 1,
  accessibility: true
});

const karusell = document.querySelector('.carousel');

if(karusell) {
  var flkty = new Flickity('.carousel');
  var carouselStatus = document.querySelector('.carousel-status');

  function updateStatus() {
    var slideNumber = flkty.selectedIndex + 1;
    carouselStatus.textContent = slideNumber + '/' + flkty.slides.length;
  }
  updateStatus();

  flkty.on( 'select', updateStatus );
}



// WEBPACK FOOTER //
// ./src/js/flickity.js